import { FileTypes } from 'taboola-ultimate-ui';
import { aiGenerationApi } from 'services/api';
import { COMPONENT_STATUS } from 'services/constants';
import { modifyExternalUrl } from '../../../services/utils';
import THUMBNAIL_SOURCE_TYPES from '../../creative-creator/config/thumbnailSourceTypes';

const fetchAIGeneratedImagesFromImage = async ({ accountId, referenceImage, setStatus }) => {
    setStatus(COMPONENT_STATUS.LOADING);

    try {
        const { images, generatedTextPrompt } = await aiGenerationApi.getAIGeneratedImagesFromImage({
            accountId,
            imageUrl: referenceImage,
        });

        const results = images.results.map(item => ({
            url: item.url,
            id: item.id,
            cdnUrl: modifyExternalUrl(item.url),
            thumbnailUrl: modifyExternalUrl(item.url),
            fileType: FileTypes.IMAGE,
            source: THUMBNAIL_SOURCE_TYPES.STABLE_DIFFUSION,
        }));

        setStatus(COMPONENT_STATUS.ACTIVE);

        return { results, generatedTextPrompt };
    } catch (error) {
        setStatus(COMPONENT_STATUS.ERROR);
        return { error, results: [] };
    }
};

export default fetchAIGeneratedImagesFromImage;
